import 'twin.macro';
import Select2 from 'components/Form/Select2';
import { ScholarSystemValue } from 'containers/scholarSystem';
import { useTranslation } from 'react-i18next';

export type Props = {
  scholarSystem: ScholarSystemValue | undefined;
  onChange: (scholarSystem: ScholarSystemValue) => void;
};

export function ScholarSystemSelector({ scholarSystem, onChange }: Props) {
  const { t } = useTranslation(['onboarding']);

  // No translation
  const options = [
    {
      label: 'Système éducatif français',
      value: 'FR',
    },
    {
      label: 'Système éducatif belge',
      value: 'BE',
    },
    {
      label: 'K-12 education',
      value: 'US',
    },
    {
      label: 'Australian Qualifications Framework',
      value: 'AU',
    },
  ] satisfies { label: string; value: ScholarSystemValue }[];

  return (
    <Select2
      label={t('onboarding:signup.scholarSystem')}
      aria-label="scholarSystem"
      large
      portal
      tw="bg-white"
      value={scholarSystem ?? 'FR'}
      options={options}
      onChange={onChange}
    />
  );
}
